// 子工程通用库文件
import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import Axios from 'axios';
import Element from 'element-ui';

// todo 这里定义的Element 对象会与window.Element对象冲突
Element.prototype = {};

function registerGlobal(root, deps) {
  Object.keys(deps).forEach(key => {
    root[key] = deps[key];
  });
}
registerGlobal(window, {
  // 在这里注册暴露给子工程的全局变量
  Vue,
  VueRouter,
  Vuex,
  Axios,
  Element,
  ElementUi: Element
});
export default registerGlobal;
